/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/
import { CognitoUserSession } from "amazon-cognito-identity-js";

export default {
  cognitoUserName(state: { cognitoUserName: string }): string {
    return state.cognitoUserName;
  },
  cognitoSub(state: { cognitoSub: string }): string {
    return state.cognitoSub;
  },
  idToken(state: { idToken: string }): string {
    return state.idToken;
  },
  session(state: { session: CognitoUserSession }): CognitoUserSession {
    return state.session;
  },
  refreshToken(state: { refreshToken: string }): string {
    return state.refreshToken;
  },
  accessToken(state: { accessToken: string }): string {
    return state.accessToken;
  },
  isAuthenticated(state: { isAuthenticated: boolean }): boolean {
    return state.isAuthenticated;
  },
  email(state: { email: string }): string {
    return state.email;
  },
  didAutoLogout(state: { didAutoLogout: boolean }): boolean {
    return state.didAutoLogout;
  },
  givenName(state: { givenName: string }): string {
    return state.givenName;
  },
  familyName(state: { familyName: string }): string {
    return state.familyName;
  },
  stationCode(state: { stationCode: string }): string {
    return state.stationCode;
  },
  loginNumber(state: { loginNumber: number }): number {
    return state.loginNumber;
  },
  companyName(state: { companyName: string }): string {
    return state.companyName;
  },
  threeDigitCode(state: { threeDigitCode: string }): string {
    return state.threeDigitCode;
  },
  parentCode(state: { parentCode: string }): string {
    return state.parentCode;
  },
  country(state: { country: string }): string {
    return state.country;
  },
  status(state: { status: string }): string {
    return state.status;
  },
  area(state: { area: string }): string {
    return state.area;
  },
  id(state: { id: number }): number {
    return state.id;
  },
  dataId(state: { dataId: string }): string {
    return state.dataId;
  },
  ftpUserId(state: { ftpUserId: string }): string {
    return state.ftpUserId;
  },
  title(state: { title: string }): string {
    return state.title;
  },
  department(state: { department: string }): string {
    return state.department;
  },
  userId(state: { userId: string }): string {
    return state.userId;
  },
  showPage(state: { showPage: boolean }): boolean {
    return state.showPage;
  },
  mainMenuCode(state: { mainMenuCode: string }): string {
    return state.mainMenuCode;
  },
  Flg(state: { Flg: boolean }): boolean {
    return state.Flg;
  },
  userdata(state: { userdata: boolean }): boolean {
    return state.userdata;
  },
  subExistMenu(state: { subExistMenu: any }): boolean {
    return state.subExistMenu;
  },
  subMenuList(state: { subMenuList: any }): boolean {
    return state.subMenuList;
  },
  subMenuItem(state: { subMenuItem: any }): boolean {
    return state.subMenuItem;
  },
  isNewsFlg(state: { isNewsFlg: boolean }): boolean {
    return state.isNewsFlg;
  },
  showPageTitle(state: { showPageTitle: string }): string {
    return state.showPageTitle;
  },
  pageClickCount(state: { pageClickCount: number }): number {
    return state.pageClickCount;
  },
  showedMenuList(state: { showedMenuList: string }): string {
    return state.showedMenuList;
  },
  newsData(state: { newsData: any }): any {
    return state.newsData;
  },
  changePage(state: { changePage: any }): any {
    return state.changePage;
  },
  stationListData(state: { stationListData: any }): any {
    return state.stationListData;
  },
  selectedStation(state: { selectedStation: any }): any {
    return state.selectedStation;
  },
  groupUserId(state: { groupUserId: string }): string {
    return state.groupUserId;
  },
  groupLName(state: { groupLName: string }): string {
    return state.groupLName;
  },
  groupFName(state: { groupFName: string }): string {
    return state.groupFName;
  },
  groupEmail(state: { groupEmail: string }): string {
    return state.groupEmail;
  },
  group(state: { group: string }): string {
    return state.group;
  },
  approvalNotice(state: { approvalNotice: string }): string {
    return state.approvalNotice;
  },
  searchedUserList(state: { searchedUserList: string }): string {
    return state.searchedUserList;
  },
  isPageLoad(state: { isPageLoad: boolean }): boolean {
    return state.isPageLoad;
  },
  pcCompanyListData(state: { pcCompanyListData: any }): any {
    return state.pcCompanyListData;
  },
  companyAdminListData(state: { companyAdminListData: any }): any {
    return state.companyAdminListData;
  },
  editStationData(state: { editStationData: any }): any {
    return state.editStationData;
  },
  fileFormatListData(state: { fileFormatListData: any}): any {
    return state.fileFormatListData;
  },
  isAltLoginAdmin(state: { isAltLoginAdmin: any; }): any {
    return state.isAltLoginAdmin
  },
  paramKDPSalesNoteList(state: { paramKDPSalesNoteList: any; }): any {
    return state.paramKDPSalesNoteList
  },
  kdpSalesNoteSearchData(state: { kdpSalesNoteSearchData: any; }): any {
    return state.kdpSalesNoteSearchData
  },
  kdpSalesNoteScreen(state: { kdpSalesNoteScreen: string }): string {
    return state.kdpSalesNoteScreen;
  },
};
